var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3233 1.67676L18.8233 4.17676L16.9175 6.08342L14.4175 3.58342L16.3233 1.67676ZM7.16663 13.3334H9.66663L15.7391 7.26092L13.2391 4.76092L7.16663 10.8334V13.3334Z",
    fill: "#111111",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 15.8333H7.29833C7.27667 15.8333 7.25417 15.8417 7.2325 15.8417C7.205 15.8417 7.1775 15.8342 7.14917 15.8333H4.66667V4.16667H10.3725L12.0392 2.5H4.66667C3.7475 2.5 3 3.24667 3 4.16667V15.8333C3 16.7533 3.7475 17.5 4.66667 17.5H16.3333C16.7754 17.5 17.1993 17.3244 17.5118 17.0118C17.8244 16.6993 18 16.2754 18 15.8333V8.61L16.3333 10.2767V15.8333Z",
    fill: "#111111",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ddd51eae1f0d578bb44fb8b6b5d721f1.svg";
export { ForwardRef as ReactComponent };